import gql from 'graphql-tag';

export const GET_CMS_COAST_CARD_DETAILS = gql`
  query getCmsCoastCardDetails($id: String!) {
    cms {
      page(id: $id) {
        contentSlots {
          name: id
          cmsComponents {
            ... on CmsShoppingGuideComponent {
              name
              typeName
              id
              sections {
                link {
                  text
                  href
                  target
                }
                name
                image {
                  format
                  altText
                  type
                  url
                }
                heading
                info,
              }
            }
          }
        }
      }
    }
  }
`;
